import { customSortCaret } from 'helpers/bootstrap_table_helper'
import { forColumnHeaderWrapper } from 'helpers/sf_utils'
import LoadingDashboardTableSkeleton from 'pages/Dashboard/LoadingDashboardTableSkeleton'
import { UI_PERMISSION_KEY } from 'pages/Roles/newFeaturesAndPermissionsData'
import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit'
import OffsetPagination from 'components/Common/OffsetPagination'
import { useSelector } from 'react-redux'
import { Card, CardBody, Col, Form, Row, TabContent, TabPane } from 'reactstrap'
import { dateCreatedFormatter } from '../Users/UserComponents/UserList/Formatters'
import useRemoteTableSort from 'hooks/useRemoteTableSort'

const DevDashboardTable = ({ fetchDmsLogsPage, onDmsLogsSortChange, dmsLogsSort }) => {

  const {
    current_user,
    current_role_permissions_state,
    dms_logs_data,
    dms_logs_data_loading,
    dms_logs_data_last_page_fetched,
    dms_logs_data_has_next_page,
    dms_logs_data_total_number_of_pages,
    dms_logs_data_has_lookahead_pages,
    dms_logs_data_lookahead_pages,
  } = useSelector((state) => ({
    current_user: state.LoginAdminUser.current_user,
    current_role_permissions_state: state.Role.current_role_permissions_state,
    dms_logs_data_last_page_fetched: state.DevDashboard.dms_logs_data_last_page_fetched,
    dms_logs_data_has_next_page: state.DevDashboard.dms_logs_data_has_next_page,
    dms_logs_data_total_number_of_pages: state.DevDashboard.dms_logs_data_total_number_of_pages,
    dms_logs_data_has_lookahead_pages: state.DevDashboard.dms_logs_data_has_lookahead_pages,
    dms_logs_data_lookahead_pages: state.DevDashboard.dms_logs_data_lookahead_pages,
    dms_logs_data: state.DevDashboard.dms_logs_data,
    dms_logs_data_loading: state.DevDashboard.dms_logs_data_loading,
  }));

  const { ExportCSVButton } = CSVExport;

  const apiColumns = [
    {
        dataField: 'timestamp',
        text: 'Timestamp',
        headerFormatter: forColumnHeaderWrapper,
        sort: true,
        formatter: dateCreatedFormatter
    },
    {
        dataField: 'message_type',
        text: 'Type',
        headerFormatter: forColumnHeaderWrapper,
        sort: true,
    },
    {
      dataField: 'log_stream',
      text: 'Log Stream',
      headerFormatter: forColumnHeaderWrapper,
      sort: true,
    },
    {
      dataField: 'message',
      text: 'Message',
      headerFormatter: forColumnHeaderWrapper,
      sort: false,
    },
  ]

  const remoteSortProps = useRemoteTableSort(
    dmsLogsSort?.sort_column || 'timestamp',
    dmsLogsSort?.sort_direction || 'desc',
    onDmsLogsSortChange,
  )

  return (
    <Row>
      <Col>
        <TabContent activeTab={'1'}>
          {dms_logs_data_loading && !dms_logs_data?.length ? <LoadingDashboardTableSkeleton rows={6} cols={apiColumns.length} /> : (
            <>
              <TabPane tabId="1">
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <ToolkitProvider
                          keyField='id'
                          columns={apiColumns}
                          data={dms_logs_data}
                          exportCSV={{
                            fileName: "DMSLogs.csv",
                            exportAll: false,
                          }}
                        >
                          {
                            toolkitProps => (
                              <React.Fragment>
                                <Form>
                                  <Col xl="auto" className="ms-auto align-items-end">
                                    <div className="mb-2">
                                      <div>
                                        {current_role_permissions_state && current_role_permissions_state.find(single_obj => single_obj.ui_key === UI_PERMISSION_KEY.EXPORT_DATA).isActive && (
                                          <ExportCSVButton className="btn btn-outline-sfblue" {...toolkitProps.csvProps}>
                                            <i className="bx bx-import font-size-14 align-middle me-2" />
                                            Export
                                          </ExportCSVButton>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Form>
                                <Row className="sfTable-Container" style={{zIndex:1}}>
                                  <Col xl="12">
                                    {!dms_logs_data?.length > 0 && dms_logs_data_loading ? (
                                      <LoadingDashboardTableSkeleton rows={6} cols={apiColumns?.length} />
                                    ) : (
                                      <BootstrapTable
                                        keyField={"id"}
                                        responsive
                                        bordered={false}
                                        striped={false}
                                        defaultSorted={remoteSortProps.defaultSorted}
                                        remote={remoteSortProps.remote}
                                        onTableChange={remoteSortProps.onTableChange}
                                        rowClasses="tr-hover"
                                        headerClasses="sftableHeader thead-h50 text-black"
                                        classes="table align-middle table-nowrap text-black"
                                        headerWrapperClasses={"thead-light"}
                                        noDataIndication="You currently don't have any data"
                                        sort={{ sortCaret: customSortCaret }}
                                        {...toolkitProps.baseProps}
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl='auto' className='ms-auto'>
                                    <OffsetPagination
                                      currentPage={dms_logs_data_last_page_fetched}
                                      totalPages={dms_logs_data_total_number_of_pages}
                                      hasNextPage={dms_logs_data_has_next_page}
                                      hasDeepOffsetPages={dms_logs_data_has_lookahead_pages}
                                      offsetLookAheadPages={dms_logs_data_lookahead_pages}
                                      loading={dms_logs_data_loading}
                                      onPageChange={fetchDmsLogsPage}
                                      className="campaign-analysis-pagination mt-3 align-items-center justify-content-end"
                                    />
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )
                          }
                        </ToolkitProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </>
          )}
        </TabContent>
      </Col>
    </Row>
  )
}

export default DevDashboardTable
